import { Input, InputRef } from "antd";

import { BaseTextAreaProps } from "./types";
import BaseError from "../BaseError";

import "./styles.css";
import { forwardRef } from "react";

const BaseTextArea = forwardRef<InputRef, BaseTextAreaProps>(
  ({ error, ...props }: BaseTextAreaProps, ref) => {
    return (
      <div className="base-text-area flex flex-col gap-200">
        <Input.TextArea
          className={error && "base-text-area-error"}
          rows={5}
          {...props}
          ref={ref}
        />

        <BaseError error={error} />
      </div>
    );
  },
);

export default BaseTextArea;
